import { Container, Graphics } from 'pixi.js';

interface Particle {
  x: number;
  y: number;
  vx: number;
  vy: number;
  life: number;
  maxLife: number;
  radius: number;
  color: number;
  alpha: number;
}

export class ParticleSystem {
  private container: Container;
  private particles: Particle[] = [];
  private graphics: Graphics = new Graphics();
  private density: number = 1;

  constructor(container: Container) {
    this.container = container;
    this.container.addChild(this.graphics);
  }

  setDensity(density: number): void {
    this.density = Math.max(0.1, Math.min(1, density));
  }

  emit(x: number, y: number, count: number, color: number, speed: number = 3, life: number = 30): void {
    const effectiveCount = Math.max(1, Math.round(count * this.density));
    for (let i = 0; i < effectiveCount; i++) {
      const angle = Math.random() * Math.PI * 2;
      const spd = (0.5 + Math.random()) * speed;

      this.particles.push({
        x,
        y,
        vx: Math.cos(angle) * spd,
        vy: Math.sin(angle) * spd,
        life,
        maxLife: life,
        radius: 1 + Math.random() * 2,
        color,
        alpha: 1,
      });
    }
  }

  emitOrbCollect(x: number, y: number): void {
    this.emit(x, y, 8, 0x44aaff, 3, 20);
  }

  emitImpact(x: number, y: number): void {
    this.emit(x, y, 10, 0xff4444, 5, 25);
  }

  emitElimination(x: number, y: number): void {
    this.emit(x, y, 20, 0xff0000, 6, 40);
  }

  update(): void {
    this.graphics.clear();

    for (let i = this.particles.length - 1; i >= 0; i--) {
      const p = this.particles[i];
      p.x += p.vx * 0.1;
      p.y += p.vy * 0.1;
      p.life--;
      p.alpha = p.life / p.maxLife;

      if (p.life <= 0) {
        this.particles.splice(i, 1);
        continue;
      }

      this.graphics.circle(p.x, p.y, p.radius * p.alpha);
      this.graphics.fill({ color: p.color, alpha: p.alpha });
    }
  }

  clear(): void {
    this.particles = [];
    this.graphics.clear();
  }
}
